import { useContext } from "react";
import { CategoriesContext } from "./CategoriesContext";

export const useCategories = () => {
  const context = useContext(CategoriesContext);

  if (!context) {
    throw new Error("useCategories must be used inside CategoriesProvider");
  }

  return context;
};
